import React from 'react';

import Folder from './Folder/Folder';

const Folders = ({ folders, draggingData, draggingFromFiles, onToggler, togglers }) => {
  return (
    <ul className="folderListContainer">
      {folders.map((f, i) => (
        <Folder
          key={f.id}
          index={i}
          file={f}
          draggingData={draggingData}
          draggingFromFiles={draggingFromFiles}
          onToggler={onToggler}
          togglers={togglers}
        />
      ))}
    </ul>
  );
};

export default Folders;
